import type { TelemetryEvent } from '@ms/yammer-telemetry';
import { isAnalyticsEvent } from '@ms/yammer-telemetry';

import type { YammerState } from '../../state/types';

import { getEtagFromStateOrPersistedState } from './selectors';

export type AddEtagToAnalyticsEvent = <T extends YammerState>(
  event: TelemetryEvent,
  getState: () => T
) => Promise<TelemetryEvent>;
export const addEtagToAnalyticsEvent: AddEtagToAnalyticsEvent = async (event, getState) => {
  if (!isAnalyticsEvent(event)) {
    return event;
  }

  const etag = await getEtagFromStateOrPersistedState(getState());
  if (!etag) {
    return event;
  }

  return {
    ...event,
    properties: {
      ...event.properties,
      ECS_ETag: etag,
    },
  };
};
